import React, { useEffect, useState } from 'react';

import Rating from './Rating';

const RatingContainer = ({
  readonly,
  value,
  ...restProps
}: { readonly: any; value: any } & Record<string, any>) => {
  const [displayValue, setDisplayValue] = useState(value);

  useEffect(() => {
    setDisplayValue(value);
  }, [value]);

  const handleMouseLeave = () => {
    if (!readonly) {
      setDisplayValue(value);
    }
  };

  const handleStarMouseMove = (event: any, index: any) => {
    if (!readonly) {
      setDisplayValue(index + 1);
    }
  };

  return (
    <Rating
      {...restProps}
      readonly={readonly}
      value={displayValue}
      onMouseLeave={handleMouseLeave}
      onStarMouseMove={handleStarMouseMove}
    />
  );
};

export default React.memo(RatingContainer) as any;
